import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import {UntypedFormGroup} from '@angular/forms';
import {Adresse} from '../../../class/api/Adresse';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { GeocoderComponent } from '../geocoder/geocoder.component';

import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-modal-adresse',
    templateUrl: './modal-adresse.component.html',
    styleUrls: ['./modal-adresse.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, GeocoderComponent, MatDialogActions, MatButton, MatDialogClose, TranslateModule]
})
export class ModalAdresseComponent implements OnInit {
    dialogRef = inject<MatDialogRef<ModalAdresseComponent>>(MatDialogRef);
    data = inject<{
    adresse?: Adresse;
}>(MAT_DIALOG_DATA);


    public form: UntypedFormGroup;

    public adresse = null;

    constructor() {
        if (this.data.adresse) {
            this.adresse = this.data.adresse;
        } else {
            this.adresse = new Adresse();
        }

    }

    ngOnInit(): void {
    }

    submit() {
        this.dialogRef.close(
            this.adresse
        );
    }

    public adresseIsValid() {
        return (
            this.isNotBlank(this.adresse.pays) &&
            this.isNotBlank(this.adresse.ville) &&
            this.isNotBlank(this.adresse.numEtVoie) &&
            this.isNotBlank(this.adresse.codePostal)
        );
    }

    public isNotBlank(value) {
        return value != null && value != '' && value != undefined;
    }

    public changeAdresse(adresse: Adresse) {
        this.adresse = {...this.adresse, ...adresse};
    }
}
